module.exports = new __parcel__URL__("time_icon_small.9749b9f4.png").toString();